/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WearablesStrictHttpResponse } from '../../wearables-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileGoalsModel } from '../../models/profile-goals-model';
import { ProfileGoalUpdateModel } from '../../models/profile-goal-update-model';

export interface ExternalMemberGoalProfileIdPost$Params {

/**
 * The member profile identifier.
 */
  profileId: string;
  
    /**
     * An array of goal updates keyed by metric type and value.
     */
    body?: Array<ProfileGoalUpdateModel>
}

export function externalMemberGoalProfileIdPost(http: HttpClient, rootUrl: string, params: ExternalMemberGoalProfileIdPost$Params, context?: HttpContext): Observable<WearablesStrictHttpResponse<ProfileGoalsModel>> {
  const rb = new RequestBuilder(rootUrl, externalMemberGoalProfileIdPost.PATH, 'post');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as WearablesStrictHttpResponse<ProfileGoalsModel>;
    })
  );
}

externalMemberGoalProfileIdPost.PATH = '/External/MemberGoal/{profileId}';
